<template>
  <div>
    <q-btn
      :size="size"
      flat
      round
      dense
      icon="navigate_before"
      @click="back"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppButtonBack",
  props: ["size"],
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
});
</script>
